import { OnInit } from '@angular/core';
import { Component, Optional, Inject } from '@angular/core';
import { IContextService } from '@pershing/pershing-core';
import { DomainContext } from '@pershing/pershing-core';
import { Subscription } from 'rxjs';
import { PershingTranslationService } from '@pershing/pershing-core';
import { NxiContextUtils } from '@pershing/nxi-common';
import { NxiWidgetParamsService } from '../../services/NXI-WidgetParams.service';
declare let dojoApp: any;

@Component({
    selector: 'fixed-income-inventory',
    templateUrl: './fixed-income-inventory.component.html'
})
export class FixedIncomeInventoryComponent implements OnInit {
    inputValue: string = '';
    domain: string = '';
    subs: Subscription;
    bonddeskurl: string = '';
    acctRef: any;
    partnerID: String = '';
    launchURL: String = '';
    isCiti: boolean = false;
    isTRP: boolean = false;
    trpUrl: string = '';
    constructor(private contextService: IContextService,
                private translationService: PershingTranslationService,
                private nxiWidgetParamsService: NxiWidgetParamsService,
                @Optional() @Inject('AppSettings') appSettings: any) {
        if (appSettings.ibdConfigMap.IBD) {
            if (appSettings.ibdConfigMap.IBD === 'C01' || appSettings.ibdConfigMap.IBD === 'H1X') {
                this.isCiti = true;
            } else if (appSettings.ibdConfigMap.IBD === '30A') {
                this.isTRP = true;
            }
        }
        this.translationService.addTranslationFolder('@pershing/nxi-ng-portfolio', 'node_modules/@pershing/nxi-ng-portfolio/lib');
    }

    ngOnInit() {
        this.subs = this.contextService.selectedDomainContext$.subscribe((domainContext: DomainContext<any>) => {
            let contextValue = NxiContextUtils.getContextFromDomainValue(domainContext);
            this.inputValue = contextValue.inputValue;
            this.acctRef = contextValue.hashValue;
            if (this.isCiti) {
                this.widgetsParamService();
            }
            if (this.isTRP) {
                this.trpUrl = '/nxi/fixed-income-inventory-popup';
                window.open(this.trpUrl, 'name', 'height=768,width=1024,resizable=yes');
            }

        });
    }

    widgetsParamService() {
        this.nxiWidgetParamsService.getWidgetParam('/commonrest/bondDeskParams').subscribe(
            resp => {
                if (resp.response) {
                    this.bonddeskurl = resp.response.launchURL;

                }
            }
        );
    }

    renderDojoWidget(): void {
        if (dojoApp) {
            dojoApp.getfixedincomeresearch(this.bonddeskurl);
        }
    }
    ngOnDestroy(): void {
        if (this.subs) {
            this.subs.unsubscribe();
        }       
    }
    handlebondDeskLink() {
        this.renderDojoWidget();
    }
}
